import { ReactElement, ReactNode } from 'react';

type Props = {
    children?: ReactNode;
};

export default function MainContainer(props: Props): ReactElement {
    const { children } = props;
    return <main className='flex min-h-screen flex-grow flex-col bg-companyLightGrey p-20 max-w-full'>{children}</main>;
}

MainContainer.defaultProps = {
    children: undefined,
};
